import moment from 'moment';

export const buildQueryParams = (query) => {
    const result = {
    };
    const shipmentsIntegrationId = query.get('shipmentsIntegrationId');
    const adjustmentsIntegrationId = query.get('adjustmentsIntegrationId');
    const hasShipmentsSource = Boolean(shipmentsIntegrationId);
    const hasAdjustmentsSource = Boolean(adjustmentsIntegrationId);
    const hasIntegrationSource = hasShipmentsSource || hasAdjustmentsSource;
    const selectedCommerceShip =
        shipmentsIntegrationId?.toLowerCase() === 'commerceship'
        || adjustmentsIntegrationId?.toLowerCase() === 'commerceship';

    if (selectedCommerceShip) {
        result.cs = true;
    } else if (hasIntegrationSource) {
        result.cs = false;
        if (shipmentsIntegrationId) {
            result.shipmentsIntegrationId = shipmentsIntegrationId;
        }
        if (adjustmentsIntegrationId) {
            result.adjustmentsIntegrationId = adjustmentsIntegrationId;
        }
    }
    if (query.has('shipStartDate')) {
        result.shipStartDate = moment(query.get('shipStartDate')).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('shipEndDate')) {
        result.shipEndDate = moment(query.get('shipEndDate')).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('domestic')) {
        if (query.get('domestic') !== 'all') {
            result.domestic = query.get('domestic') === 'domestic';
        }
    }
    if (query.has('ground')) {
        if (query.get('ground') !== 'all') {
            result.ground = query.get('ground') === 'ground';
        }
    }
    if (query.has('service_levels')) {
        result.serviceLevelGroups = query.getAll('service_levels');
    }
    if (query.has('carriers')) {
        result.carriers = query.getAll('carriers');
    }
    if (query.has('timeframe')) {
        result.timeframe = query.get('timeframe');
    }
    if (query.has('trackingNumber')) {
        result.trackingNumbers = query.getAll('trackingNumber');
    }
    if (query.has('includeRefunds')) {
        result.includeRefunds = query.get('includeRefunds') === 'true';
    }
    if (query.has('includeMatches')) {
        result.includeMatches = query.get('includeMatches') === 'true';
    }
    if (query.has('warehouse_id')) {
        result.warehouseIds = query.getAll('warehouse_id');
    }
    if (query.has('zones')) {
        result.zones = query.getAll('zones');
    }
    if (query.has('page_size')) {
        result.page_size = query.get('page_size');
    }
    if (query.has('page')) {
        result.page = query.get('page');
    }
    return result;
};
